export default {
    Period: 'Chọn kỳ báo cáo',
    FromDate: 'Từ ngày',
    ToDate: 'Đến ngày',
    ChinhLyQuyetToan: 'In tháng chỉnh lý quyết toán',
    BaoGomChinhLyQuyetToan: 'Bao gồm chứng từ chỉnh lý quyết toán',
    Level: 'In đến bậc',
    ViewReport: 'Xem báo cáo',
    Cancel: 'Hủy',
    ReportParam: 'Tham số báo cáo',
    Help: 'Trợ giúp',
    Grade: 'Bậc {0}',
    OpeningPeriod: 'Số dư đầu kỳ',
    OpeningYear: 'Số dư đầu năm',
    ClosingPeriod: 'Số dư cuối kỳ',
    ClosingYear: 'Số dư cuối năm',
    ThangChinhLy: 'Tháng chỉnh lý quyết toán',
    ThisMonth: 'Tháng này',
    ThuyetMinhKhac: 'Thuyết minh khác',
    LayBaoCaoTaiChinh: 'Lấy dữ liệu từ báo cáo tài chính đã lập',
    KhongHopLe: 'Không hợp lệ',
    Notify: 'Báo cáo B01-x: Báo cáo tài chính {0} chưa được lập.',
    LapBaoCao: 'Lập báo cáo',
    Close: 'Đóng',
    InDate: 'Tại ngày {0} tháng {1} năm {2}',
    OpeningPeriod_2: 'Số đầu kỳ',
    OpeningYear_2: 'Số đầu năm',
    ClosingPeriod_2: 'Số cuối kỳ',
    ClosingYear_2: 'Số cuối năm',
    ThisYear: 'Năm nay',
    LastYear: 'Năm trước',
    ThisPeriod: 'Kỳ này',
    LastPeriod: 'Kỳ trước',
    KyBaoCao: 'Kỳ báo cáo'
};
